import { create } from 'zustand'
import type { Decision } from '../types'

interface DecisionStore {
  draft: Decision
  setStart: (ids: string[]) => void
  toggleStart: (id: string) => void
  toggleStop: (id: string) => void
  toggleOneShot: (id: string) => void
  setTempo: (v: number) => void
  setBoardRequest: (b: boolean) => void
  reset: () => void
}

const emptyDraft: Decision = {
  programs_to_start: [],
  programs_to_stop: [],
  one_shots: [],
  tempo: 1.0,
  request_board_budget_increase: false,
}

export const useDecisionStore = create<DecisionStore>((set) => ({
  draft: emptyDraft,
  setStart: (ids) => set((s) => ({ draft: { ...s.draft, programs_to_start: ids } })),
  toggleStart: (id) => set((s) => {
    const xs = s.draft.programs_to_start
    return { draft: { ...s.draft, programs_to_start:
      xs.includes(id) ? xs.filter(x => x !== id) : [...xs, id] } }
  }),
  toggleStop: (id) => set((s) => {
    const xs = s.draft.programs_to_stop
    return { draft: { ...s.draft, programs_to_stop:
      xs.includes(id) ? xs.filter(x => x !== id) : [...xs, id] } }
  }),
  toggleOneShot: (id) => set((s) => {
    const xs = s.draft.one_shots
    return { draft: { ...s.draft, one_shots:
      xs.includes(id) ? xs.filter(x => x !== id) : [...xs, id] } }
  }),
  setTempo: (v) => set((s) => ({ draft: { ...s.draft, tempo: v } })),
  setBoardRequest: (b) => set((s) => ({ draft: { ...s.draft, request_board_budget_increase: b } })),
  reset: () => set({ draft: emptyDraft }),
}))
